<template>
  <v-container class="main-container responsive-height">
    <ClientUserStatistics></ClientUserStatistics>
    <ProfileBar></ProfileBar>
    <AllLevelTabs></AllLevelTabs>
  </v-container>
</template>

<script>
import AllLevelTabs from '@/components/MyClients/ClientTreeLevelFive/AllLevelTabs.vue';
import ClientUserStatistics from '@/components/MyClients/ClientTreeLevelFive/ClientUserStatistics.vue';
import ProfileBar from '@/components/MyClients/ClientsTreeAndEarning/ProfileBar.vue';

export default {
  components: {
    ClientUserStatistics,
    AllLevelTabs,
    ProfileBar,
  },
};
</script>
